export { TutorPrescriptionStudentCard, type TutorPrescriptionStudentCardProps } from "./TutorPrescriptionStudentCard"
